export enum PaymentTypes {
  METHOD_CASH='cash',
  METHOD_CHEQUE='cheque',
  METHOD_BANK='bank',
  METHOD_MFS='mfs',
}
